import { render, staticRenderFns } from "./VoucherTableHeadButton.vue?vue&type=template&id=2f7b51e9&scoped=true"
import script from "./VoucherTableHeadButton.vue?vue&type=script&setup=true&lang=js"
export * from "./VoucherTableHeadButton.vue?vue&type=script&setup=true&lang=js"
import style0 from "./VoucherTableHeadButton.vue?vue&type=style&index=0&id=2f7b51e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7b51e9",
  null
  
)

export default component.exports